export function normalizeDefaultLanguage(
  default_language,
  available_languages
) {
  const dflt = default_language || "";
  const list = available_languages || [];
  if (dflt) {
    const index = list.indexOf(dflt);
    if (index > -1) {
      const newList = [...list];
      newList.splice(index, 1);
      return { default_language: dflt, available_languages: newList };
    }
  }
  return { default_language: dflt, available_languages: list };
}
